import {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import moment from "moment";
import toast from "react-hot-toast";

import {
  GragIntakeSheetData,
} from "../assignmentOfBenefit/Service";

import {
  IntakeSheetSession,
  MedicalLienConstant,
  RoleType,
  CurrentProviderData,
} from "../../../helpers/constant";
import "./MedicalLien.css";
import { getSessionStorage } from "../../../helpers/storage";
import { GetCaseFormListData, SaveCaseFormData } from "./services3";
import SignaturePad from "../../../Component/shared/signaturePad";
import SpinnerLoader from "../../../Component/shared/loader/spinnerLoader/SpinnerLoader";
import { usePatientData } from "../../../commonFunction/storage/Patientdatacontext";



const MedicalLien = forwardRef(function MedicalLien(props, ref) {
  const {
    providerOptions = [],
    sessionData = {},
    signatureMiss,
    copySignature,
  } = props;

  const tokenData = JSON.parse(sessionStorage.getItem("tokenData") || "{}");

  const providerData = getSessionStorage(CurrentProviderData) || [];
  const roleName = sessionData?.Role?.Name?.trim().toLowerCase() ?? "";
  const isFrontDesk = roleName === "frontdesk" || roleName === "front desk" || roleName === "admin";

  /* ── state ── */
  const [loading, setLoading] = useState(false);
  const [caseFormDataId, setCaseFormDataId] = useState("");
  const [collectionOfML, setCollectionOfML] = useState([]);
  const [beforeParsingML, setBeforeParsingML] = useState([]);  // same as HippaAuth

  // form fields
  const [manThosePresent, setManThosePresent] = useState("");
  const [residingAt, setResidingAt] = useState("");
  const [considerationDr, setConsiderationDr] = useState("");
  const [beginingDate, setBeginingDate] = useState(new Date());
  const [assignTransferDr, setAssignTransferDr] = useState("");
  const [partOfAnyAbout, setPartOfAnyAbout] = useState("");
  const [amount, setAmount] = useState("");
  const [toTheDr, setToTheDr] = useState("");
  const [drNameFirst, setDrNameFirst] = useState("");
  const [drNameSecond, setDrNameSecond] = useState("");
  const [setMyHandDate, setSetMyHandDate] = useState(new Date());
  const [patientName, setPatientName] = useState("");
  const [attorneyName, setAttorneyName] = useState("");
  const [patientSignImg, setPatientSignImg] = useState("");
  const [attorneySignImg, setAttorneySignImg] = useState("");
  const [DOS, setDOS] = useState(new Date());
  const [addressOfAttorney, setAddressOfAttorney] = useState("");
  const [providerAddress, setProviderAddress] = useState("");
  const [selectedProvider, setSelectedProvider] = useState(providerOptions[0] || null);
  const [isSelectedProvider, setIsSelectedProvider] = useState(false); // eslint-disable-line no-unused-vars

  // signature pad
  const [sigPadOpen, setSigPadOpen] = useState(false);
  const [signRole, setSignRole] = useState("");

  const { patientData, fetchPatientData } = usePatientData();

 useImperativeHandle(ref, () => ({
    save:           () => saveFunction(true),
    isPending:      () => !patientSignImg,
     getSignature:   () => patientSignImg || "",   
    applySignature: (sig) => {
      if (!sig) return;
      setPatientSignImg(sig);
      setDOS(new Date());
    },
    }), [patientSignImg, DOS]);

useEffect(() => {
  props?.onReady?.("med_lien");
  }, [patientSignImg]);

  useEffect(() => {
    callApi();
  }, [patientData]);


  const callApi = async () => {
    setLoading(true);
    const formData = await handleGetCaseFormData();
    const patientInfo = patientData || await fetchPatientData(tokenData?.caseId, tokenData?.companyId);

    if (!formData?.JsonData) {
      console.error("No JsonData returned from GetCaseFormListData");
      setLoading(false);
      return;
    }

    const mlData = JSON.parse(formData.JsonData);
    const collection = GragIntakeSheetData(mlData);

    setCollectionOfML(collection);
    setBeforeParsingML(mlData);
    setCaseFormDataId(formData.CaseFormDataId || "");

    bindValueToControl(collection, patientInfo);
    setLoading(false);
  };

  /* ══════════════════════════════════════════════════
    FETCH CASE FORM DATA — same as HippaAuth
  ══════════════════════════════════════════════════ */
  const handleGetCaseFormData = async () => {
    try {
      const requestBody = {
        CaseFormDataId: null,
        CaseId: tokenData.caseId,
        CompanyId: tokenData.companyId,
        DoctorId: "ALL",
        EntityLevel: 0,
        FormId: 6,               // ← intakeSheetId for Medical Lien from ALL_TABS
        FormName: "Medical Lien",
        FormType: null,
        IsFormCompleted: false,
        JsonData: null,
        TemplateName: null,
        UserId: tokenData?.userId
      };

      const response = await GetCaseFormListData(requestBody);

      if (response?.HasException) {
        toast.error(`Something went wrong. ${response?.MessageText}. ${response?.Exception}`);
        return {};
      }

      return response?.Data?.[0] || {};
    } catch (error) {
      toast.error(error.message);
      return {};
    }
  };



  const CallSaveApiForIntakeSheet = async (jsonData) => {
    try {
      setLoading(true);

      const doctorId = isFrontDesk
        ? (providerOptions.length === 1 ? providerOptions[0]?.value : selectedProvider?.value) || ""
        : providerData[0]?.ProviderId || tokenData?.doctorId || "";

      const payload = {
        CaseFormDataId:  "48490",
        CaseId:          tokenData.caseId,
        CompanyId:       tokenData.companyId,
        DoctorId:        doctorId,
        EntityLevel:     0,
        FormId:          6,              
        FormName:        "Medical Lien",
        FormType:        null,
        IsChanged:       false,
        IsCopySign:      false,
        IsFormCompleted: false,
        TemplateName: null,
        UserId: tokenData?.userId ,
        officeId: tokenData?.providerId,
        JsonData: jsonData,
      };

      const response = await SaveCaseFormData(payload);

      if (response?.HasException) {
        toast.error(`Error while saving Medical Lien.`);
        return false
      } else {
        if (response?.Data?.[0]?.CaseFormDataId) {
          setCaseFormDataId(response.Data[0].CaseFormDataId);
        }
        toast.success("Medical Lien saved successfully.");
        return true
      }
    } catch (err) {
      console.error("CallSaveApiForIntakeSheet error:", err);
      toast.error("Error while saving Medical Lien data.");
        return false
    } finally {
      setLoading(false);
    }
  };

  const bindValueToControl = (collection, patientInfo) => {
    if (!patientInfo) return;

    const getValue = (key) => {
      const found = collection.find((x) => x.Name === key);
      return found ? found.Value : "";
    };

    const normalise = (raw) => {
      if (!raw) return "";
      return raw.includes(IntakeSheetSession.dataBlock) ? raw : IntakeSheetSession.dataBlock + raw;
    };

    const parseDateSafe = (raw) =>
      isNaN(new Date(raw).getTime()) ? "" : new Date(raw);

    // Patient name
    const fullName = [
      patientInfo.patientFirstName,
      patientInfo.patientMiddleName,
      patientInfo.patientLastName,
    ].filter(Boolean).join(" ");

    // Patient address
    const address = [
      patientInfo.patientAddress,
      patientInfo.patientStreet,
      patientInfo.patientCity,
      patientInfo.patientState,
      patientInfo.patientZIP,
    ].filter(Boolean).join(", ");

    // Attorney fields
    const aName = [patientInfo.attorneyFirstName, patientInfo.attorneyLastName]
      .filter(Boolean).join(" ");
    const aAddr = [patientInfo.attorneyAddress, patientInfo.attorneyCity,
    patientInfo.attorneyState, patientInfo.attorneyZIP]
      .filter(Boolean).join(", ");

    // Provider
    if (isFrontDesk) {
      const provNameRaw = getValue(MedicalLienConstant.PhysicianName1);
      const provider = providerOptions.find((x) => x.label === provNameRaw) || providerOptions[0] || null;
      const forAddr = providerData.find((x) => x.ProviderId === provider?.value);
      const provAddr = forAddr
        ? [forAddr.Address, forAddr.City, forAddr.Street, forAddr.State, forAddr.Zip].filter(Boolean).join(", ")
        : "";
      const provName = provider?.label || "";
      setSelectedProvider(provider);
      setProviderAddress(provAddr);
      setConsiderationDr(provName);
      setAssignTransferDr(provName);
      setToTheDr(provName);
      setDrNameFirst(provName);
      setDrNameSecond(provName);
    } else {
      const prov = providerData[0] || {};
      const provName =
        getValue(MedicalLienConstant.PhysicianName1) ||
        prov.ProviderName ||
        tokenData?.providerName ||
        tokenData?.ProviderName ||
        "";
      if (provName) {
        setConsiderationDr(provName);
        setAssignTransferDr(provName);
        setToTheDr(provName);
        setDrNameFirst(provName);
        setDrNameSecond(provName);
      }
    }

    if (fullName) { setManThosePresent(fullName); setPatientName(fullName); }
    if (address) setResidingAt(address);

    setBeginingDate(parseDateSafe(getValue(MedicalLienConstant.BeginingDate)) || new Date());
    setPartOfAnyAbout(getValue(MedicalLienConstant.AboutText) || getValue(MedicalLienConstant.PatientAddress));
    setAmount(getValue(MedicalLienConstant.Amount));
    setSetMyHandDate(parseDateSafe(getValue(MedicalLienConstant.HereOntuDate)) || new Date());
    setAttorneyName(aName);
    // setPatientSignImg(normalise(getValue(MedicalLienConstant.PatientSign)));
    const savedSig = copySignature ? sessionStorage.getItem("sharedPatientSignature") : null;
    setPatientSignImg(savedSig || normalise(getValue(MedicalLienConstant.PatientSign)));
    setAttorneySignImg(normalise(getValue(MedicalLienConstant.AttorneySign)));
    setDOS(parseDateSafe(getValue(MedicalLienConstant.PatientSignDate)) || new Date());
    setAddressOfAttorney(aAddr);

    if (!getValue(MedicalLienConstant.PatientSign)) signatureMiss?.(true);
    setLoading(false);
  };

  /* ══════════════════════════════════════════════════
    UPDATE COLLECTION — same as HippaAuth's updateCollection
  ══════════════════════════════════════════════════ */
  const updateCollection = (collection) => {
    const updated = [...collection];

    const set = (key, value) => {
      const item = updated.find((x) => x.Name === key);
      if (item) item.Value = value;
    };

    const fmt = (d) =>
      d == null || d === ""
        ? ""
        : moment(d).format("MM-DD-YYYY").split("-").join("/");

    const provName = isFrontDesk && providerOptions.length === 1
      ? providerOptions[0]?.label || ""
      : selectedProvider?.label || "";

    set(MedicalLienConstant.PatientName1, manThosePresent);
    set(MedicalLienConstant.PatientAddress, residingAt);
    set(MedicalLienConstant.PhysicianName1, isFrontDesk && providerOptions.length === 1 ? provName : considerationDr || provName);
    set(MedicalLienConstant.BeginingDate, fmt(beginingDate));
    set(MedicalLienConstant.PhysicianName2, isFrontDesk && providerOptions.length === 1 ? provName : assignTransferDr || provName);
    set(MedicalLienConstant.AboutText, partOfAnyAbout);
    set(MedicalLienConstant.Amount, amount);
    set(MedicalLienConstant.PhysicianName3, isFrontDesk && providerOptions.length === 1 ? provName : toTheDr || provName);
    set(MedicalLienConstant.PhysicianName4, isFrontDesk && providerOptions.length === 1 ? provName : drNameFirst || provName);
    set(MedicalLienConstant.PhysicianName5, isFrontDesk && providerOptions.length === 1 ? provName : drNameSecond || provName);
    set(MedicalLienConstant.HereOntuDate, fmt(setMyHandDate));
    set(MedicalLienConstant.PatientName2, patientName);
    set(MedicalLienConstant.AttorneyName, attorneyName);
    set(MedicalLienConstant.PatientSign, patientSignImg);
    set(MedicalLienConstant.AttorneySign, attorneySignImg);
    set(MedicalLienConstant.PatientSignDate, fmt(DOS));
    set(MedicalLienConstant.AttorneyAddress, addressOfAttorney);

    return updated;
  };

  /* ══════════════════════════════════════════════════
    formJsonRequest — same as HippaAuth's formJsonRequest
    Mutates beforeParsingML notesdata then calls save API
  ══════════════════════════════════════════════════ */
  const formJsonRequest = async (updatedCollection, beforeData) => {
    try{
    for (let i = 0; i < beforeData.notesdata.length; i++) {
      const filterDataArr = updatedCollection.filter(
        (x) => x.RenderKeyName === beforeData.notesdata[i].RenderKeyName,
      );
      if (!filterDataArr.length) continue;

      for (let j = 0; j < beforeData.notesdata[i].ApplicationValue.length; j++) {
        if (
          beforeData.notesdata[i].ApplicationValue[j].Name !== filterDataArr[j]?.Name
        ) continue;

        beforeData.notesdata[i].ApplicationValue[j].Type = filterDataArr[j].Type;
        beforeData.notesdata[i].ApplicationValue[j].isRender = filterDataArr[j].isRender;

        const isSign =
          beforeData.notesdata[i].ApplicationValue[j].Name === MedicalLienConstant.PatientSign ||
          beforeData.notesdata[i].ApplicationValue[j].Name === MedicalLienConstant.AttorneySign;

        if (isSign) {
          const val = filterDataArr[j].Value;
          if (val) {
            if (val.includes(";")) {
              beforeData.notesdata[i].ApplicationValue[j].Value = val.split(";")[1].split(",")[1];
            } else {
              beforeData.notesdata[i].ApplicationValue[j].Value = val;
            }
          } else {
            beforeData.notesdata[i].ApplicationValue[j].Value = "";
          }
        } else {
          beforeData.notesdata[i].ApplicationValue[j].Value = filterDataArr[j].Value;
        }
      }
    }

    const result = await CallSaveApiForIntakeSheet(JSON.stringify(beforeData));
    setCollectionOfML(updatedCollection);
    setBeforeParsingML(beforeData);
    return result;
    }catch (error) {
      console.error(error.message)
    }
  };

  const saveFunction = async () => {
    setLoading(true);
    const updatedCollection = updateCollection(collectionOfML);
    const beforeDataClone = JSON.parse(JSON.stringify(beforeParsingML));
    const result = await formJsonRequest(updatedCollection, beforeDataClone);
    setLoading(false);
    return result;
  };

  const clickPatientSign  = () => { setSignRole(RoleType.Patient);  setSigPadOpen(true); };

  const signUpdatedCall = (base64Img) => {
    const newBase = base64Img.includes(IntakeSheetSession.dataBlock1)
      ? base64Img.replace(IntakeSheetSession.dataBlock1, IntakeSheetSession.dataBlock)
      : base64Img;
    if (signRole === RoleType.Attorney) {
      setAttorneySignImg(newBase);
    }
    if (signRole === RoleType.Patient) {
      setPatientSignImg(newBase);
      setDOS(new Date());
      sessionStorage.setItem("sharedPatientSignature", newBase); // CHANGED
    }
  };

  const clearSignCall = () => {
    if (signRole === RoleType.Patient) { setPatientSignImg(""); signatureMiss?.(true); }
    if (signRole === RoleType.Attorney) { setAttorneySignImg(""); }
  };

  /* ══════════════════════════════════════════════════
    PROVIDER CHANGE
  ══════════════════════════════════════════════════ */
  const onProviderChange = (prov) => {
    if (!prov) return;
    const forAddr = providerData.find((x) => x.ProviderId === prov.value);
    const addr = forAddr
      ? [forAddr.Address, forAddr.City, forAddr.Street, forAddr.State, forAddr.Zip].filter(Boolean).join(", ")
      : "";
    const provName = prov.label || "";
    setSelectedProvider(prov);
    setProviderAddress(addr);
    setConsiderationDr(provName);
    setAssignTransferDr(provName);
    setToTheDr(provName);
    setDrNameFirst(provName);
    setDrNameSecond(provName);
    setIsSelectedProvider(false);
  };

  /* ══════════════════════════════════════════════════
    PROVIDER FIELD
  ══════════════════════════════════════════════════ */
  const ProviderField = () =>
    providerOptions.length === 1 ? (
      <input
        className="ml__input"
        type="text"
        value={providerOptions[0]?.label || ""}
        readOnly
      />
    ) : (
      <Select
        options={providerOptions}
        onChange={onProviderChange}
        value={selectedProvider}
        getOptionLabel={(e) => e?.label}
        getOptionValue={(e) => e?.value}
        tabSelectsValue={false}
        classNamePrefix="react-select"
        placeholder="Select Provider"
      />
    );


  return (
        <>
      {loading ? (
        <SpinnerLoader message="Loading form data…" />
      ) : (
    <div className="ml__wrapper">

      {/* ── Title ── */}
      <div className="ml__title-block">
        <div className="ml__title-main">MEDICAL LIEN</div>
      </div>

      {/* ── Know all man ── */}
      <div className="ml__sentence-row">
        <span className="ml__label"><b>Know all man by those present that I:</b></span>
        <input
          className="ml__input ml__input--grow"
          type="text"
          value={manThosePresent}
          onChange={(e) => setManThosePresent(e.target.value)}
          disabled
        />
      </div>

      {/* ── Residing at ── */}
      <div className="ml__sentence-row">
        <span className="ml__label"><b>Residing at:</b></span>
        <input
          className="ml__input ml__input--grow"
          type="text"
          value={residingAt}
          onChange={(e) => setResidingAt(e.target.value)}
          disabled
        />
      </div>

      {/* ── Consideration ── */}
      <div className="ml__sentence-row ml__sentence-row--wrap">
        <span className="ml__label"><b>For and in consideration of medical care and services tendered and hereafter and rendered to me by Dr.</b></span>
        <div className="ml__provider-field">
          {isFrontDesk
            ? <ProviderField />
            : <input className="ml__input" type="text" value={considerationDr} onChange={(e) => setConsiderationDr(e.target.value)} disabled />
          }
        </div>
      </div>

      {/* ── Beginning date + assign transfer ── */}
      {/* <div className="ml__sentence-row ml__sentence-row--wrap"> */}
      {/* <div className="ml__sentence-row ml__sentence-row--inline"> 
          <span className="ml__label"><b>Beginning With the</b></span>
          <DatePicker
            selected={beginingDate}
            onChange={(d) => setBeginingDate(d)}
            dateFormat="MM/dd/yyyy"
            className="ml__datepicker"
            showYearDropdown showMonthDropdown dropdownMode="select"
          />
          <span className="ml__label"><b>Do hereby assign, transfer and set over unto Dr.</b></span>
          <div className="ml__provider-field">
            {isFrontDesk
              ? <ProviderField />
              : <input className="ml__input" type="text" value={assignTransferDr} onChange={(e) => setAssignTransferDr(e.target.value)} disabled />
            }
          </div>
        </div> */}
      <div className="ml__sentence-row ml__sentence-row--inline">

        {/* Left half */}
        <div className="ml__inline-left">
          <span className="ml__label"><b>Beginning With the</b></span>
          <DatePicker
            selected={beginingDate}
            onChange={(d) => setBeginingDate(d)}
            dateFormat="MM/dd/yyyy"
            className="ml__datepicker"
            showYearDropdown showMonthDropdown dropdownMode="select"
          />
        </div>

        {/* Right half */}
        <div className="ml__inline-right">
          <span className="ml__label"><b>Do hereby assign, transfer and set over unto Dr.</b></span>
          <div className="ml__provider-field">
            {isFrontDesk
              ? <ProviderField />
              : <input
                className="ml__input"
                type="text"
                value={assignTransferDr}
                onChange={(e) => setAssignTransferDr(e.target.value)}
                disabled
              />
            }
          </div>
        </div>

      </div>

      {/* ── Part of any about ── */}
      <div className="ml__sentence-row">
        <span className="ml__label"><b>Such part of any about</b></span>
        <input
          className="ml__input ml__input--grow"
          type="text"
          value={partOfAnyAbout}
          onChange={(e) => setPartOfAnyAbout(e.target.value)}
          disabled
        />
      </div>

      {/* ── Legal paragraph ── */}
      <div className="ml__legal-para">
        <b>As is necessary to pay in full said medical services and I further consent, agree and stipulate that said medical-fees
          and/or charges shall constitute a primary lien which may be placed or charged against such judgment, settlement, funds
          or proceeds of any such claim or action occurred and/or obtained as a result of any such claim or action I may have
          regardless of who may be in possession of such funds of proceeds. I hereby authorize and direct such person or persons,
          party of parties, firm or firms, corporation or corporations who will or may be or become indebted to me as a result
          thereof to pay over in the</b>
      </div>

      {/* ── Amount + to the Dr ── */}
      <div className="ml__sentence-row ml__sentence-row--wrap">
        <span className="ml__label"><b>Amount of $</b></span>
        <input
          className="ml__input ml__input--amount"
          type="text"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <span className="ml__label"><b>to the Dr.</b></span>
        <div className="ml__provider-field">
          {isFrontDesk
            ? <ProviderField />
            : <input className="ml__input" type="text" value={toTheDr} onChange={(e) => setToTheDr(e.target.value)} disabled />
          }
        </div>
        <span className="ml__label"><b>or their assignee for such medical services,</b></span>
      </div>

      {/* ── Legal paragraph 2 ── */}
      <div className="ml__legal-para">
        <b>Without further notice to such parties from me and I agree to hold such parties harmless on account of any such
          payments made. I hereby authorize and direct my attorney or attorneys or any other person or persons unto whose hands
          or possession any of the said funds, proceeds or monies shall come, to hold in trust and pay over to the</b>
      </div>

      {/* ── Dr name first ── */}
      <div className="ml__sentence-row ml__sentence-row--wrap">
        <span className="ml__label"><b>Dr.</b></span>
        <div className="ml__provider-field">
          {isFrontDesk
            ? <ProviderField />
            : <input className="ml__input" type="text" value={drNameFirst} onChange={(e) => setDrNameFirst(e.target.value)} disabled />
          }
        </div>
        <span className="ml__label"><b>or his assigns such sums as are claimed by said Dr.</b></span>
      </div>

      {/* ── Dr name second ── */}
      <div className="ml__sentence-row ml__sentence-row--wrap">
        <span className="ml__label"><b>Dr.</b></span>
        <div className="ml__provider-field">
          {isFrontDesk
            ? <ProviderField />
            : <input className="ml__input" type="text" value={drNameSecond} onChange={(e) => setDrNameSecond(e.target.value)} disabled />
          }
        </div>
        <span className="ml__label"><b>or his assigns such medical care and services as herein before referred to. IN WITNESS WHEREOF,</b></span>
      </div>

      {/* ── Set my hand date ── */}
     <div className="ml__sentence-row" style={{ flexWrap: "nowrap", alignItems: "center" }}>
        <span className="ml__label" style={{ whiteSpace: "nowrap" }}><b>I have hereunto set my hand this</b></span>
        <DatePicker
          selected={setMyHandDate}
          onChange={(d) => setSetMyHandDate(d)}
          dateFormat="MM/dd/yyyy"
          className="ml__datepicker"
          showYearDropdown showMonthDropdown dropdownMode="select"
        />
      </div>

      {/* ── Acknowledge note ── */}
       <div className="ml__acknowledge">
        <b>Please acknowledge your acceptance of the lien by signing below and returning to me:</b>
      </div>

      {/* ── Name row ── */}
      <div className="ml__grid-row">
        <span className="ml__grid-label"><b>Name :</b></span>
        <input
          className="ml__input"
          type="text"
          value={patientName}
          onChange={(e) => setPatientName(e.target.value)}
          disabled
        />
        <span className="ml__grid-label"><b>Name Of Attorney:</b></span>
        <input
          className="ml__input"
          type="text"
          value={attorneyName}
          onChange={(e) => setAttorneyName(e.target.value)}
          disabled
        />
      </div>

      {/* ── Signature boxes ── */}
      <div className="ml__grid-row">
        <span className="ml__grid-label"><b>Signature :</b></span>
        <div
          className={`ml__sign-box${!patientSignImg ? " ml__sign-box--empty" : ""}`}
          onClick={clickPatientSign}
        >
          {patientSignImg
            ? <img src={patientSignImg} alt="Patient signature" className="ml__sign-img" />
            : <span className="ml__sign-hint">Click to sign</span>
          }
        </div>
        <span className="ml__grid-label"><b>Signature Of Attorney:</b></span>
        <div
          className="ml__sign-box ml__sign-box--disabled"
        >
          {attorneySignImg && (
            <img src={attorneySignImg} alt="Attorney signature" className="ml__sign-img" />
          )}
        </div>
      </div>

      {/* ── Date + Attorney address ── */}
      <div className="ml__grid-row ml__grid-row--bottom">
        <span className="ml__grid-label"><b>Date of Signature:</b></span>
        <DatePicker
          selected={DOS}
          onChange={(d) => setDOS(d)}
          dateFormat="MM/dd/yyyy"
          className="ml__datepicker"
          showYearDropdown showMonthDropdown dropdownMode="select"
          popperPlacement="top-start"
         portalId="root"
        />
        <span className="ml__grid-label"><b>Address of Attorney:</b></span>
        <textarea
          className="ml__textarea"
          value={addressOfAttorney}
          onChange={(e) => setAddressOfAttorney(e.target.value)}
          disabled
        />
      </div>

      {/* ── Signature Pad Modal ── */}
      <SignaturePad
        isOpen={sigPadOpen}
        title={signRole === RoleType.Patient ? "Patient Signature" : "Attorney Signature"}
        existingSign={signRole === RoleType.Patient ? patientSignImg : attorneySignImg}
        onClose={() => setSigPadOpen(false)}
        onSave={(base64) => { signUpdatedCall(base64); setSigPadOpen(false); }}
        onClear={clearSignCall}
      />

    </div>
          )}
    </>
  );
});

export default MedicalLien;